<script>
import { ref, onMounted } from 'vue'
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'

export default {
  setup( props, { slots } ) {
    const brkpnts  = useBreakpoints(breakpointsTailwind)
    const mobile   = brkpnts.smaller('md')
    const open     = ref(false)
    const toggle   = () => open.value = ! open.value
    const scrollTo = ( id ) => {
      const head      = document.getElementById( 'shopify-section-layout-header' )
      const headH     = head.offsetHeight
      const target    = document.querySelector( id )
      const rect      = target.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const targetPos = ( rect.top + scrollTop ) - headH
      window.scrollTo({
        top : targetPos,
        behavior : "smooth"
      })
    }
    
    return () => slots.default( {
      mobile : mobile.value,
      open : open.value,
      toggle,
      scrollTo
    } )
  }
}
</script>